// removed by extract-text-webpack-plugin
module.exports = {"header":"styles__header___P9w1l"};


/*****************
 ** WEBPACK FOOTER
 ** ./modules/components/Dragon/styles.css
 ** module id = 304
 ** module chunks = 1
 **/